
/**
 * 플랫폼 지원
 */
export type CourseLecturePlatformSupport = typeof CourseLecturePlatformSupport[keyof typeof CourseLecturePlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseLecturePlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
